import images from '@assets/images/index'
import { Col, Flex, Progress } from 'antd'

interface MyQuestStickersCardProps {
  earnedStickers: number
  stickerTarget: number
  maxPercentage: number
  step: number
}

const MyQuestStickersCard = ({
  earnedStickers,
  stickerTarget,
  maxPercentage,
  step
}: MyQuestStickersCardProps) => {
  const remainingStickers = Math.max(0, stickerTarget - earnedStickers)
  const progressPercent = Math.min(
    maxPercentage,
    (earnedStickers / stickerTarget) * maxPercentage
  )

  return (
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
      <Flex justify="center" align="center" vertical className="my-quest-col">
        <Flex justify="center" align="center" gap={10}>
          <images.StarIcon />
          <span className="quest-number">{earnedStickers}</span>
        </Flex>
        <Flex vertical align="center" gap={25} className="quest-graph">
          <span className="month-name">Weekly Stickers</span>
          <Progress
            steps={step}
            percent={progressPercent}
            size={20}
            showInfo={false}
            status={earnedStickers >= stickerTarget ? 'success' : 'active'}
          />
        </Flex>
        <Flex vertical gap={step} align="center">
          <h4 className="quest-title">
            {remainingStickers > 0
              ? `Only ${remainingStickers} more stickers to go!`
              : 'Congratulations! You have reached your sticker goal!'}
          </h4>
        </Flex>
      </Flex>
    </Col>
  )
}

export default MyQuestStickersCard
